<div class="box-theme">
  <div class="head">
    <div class="body">
      <div class="header">
        <h1>
          Si usted es cliente de Metrogas y pertenece a una de estas categorías, <br/>
          puede solicitar Beneficio Covid-19, que le permitirá acceder a la <br/>
          postergación del pago de su cuenta hasta en 48 cuotas sin interés.
        </h1>
      </div>
    </div>
  </div>
  <div class="body">
    <div class="counter-pasos">
      <ul class="stepper-lineas">
        <li>
          <span class="linea-current"></span>
        </li>
        <li></li>
      </ul>
      <ul class="stepper">
        <li [ngClass]="{ 'numActive':pasos[0]['P1'].CurrentNum === true }">
          <p>1</p>
        </li>
        <li [ngClass]="{ 'numActive':pasos[0]['P2'].CurrentNum === true }">
          <p>2</p>
        </li>
        <li [ngClass]="{ 'numActive':pasos[0]['P3'].CurrentNum === true }">
          <p>3</p>
        </li>
        <li [ngClass]="{ 'numActive':pasos[0]['P4'].CurrentNum === true }">
          <p>4</p>
        </li>
      </ul>
    </div>
    <!-- PASO NUMERO 1 -->
    <div class="paso-1" *ngIf="pasos[0]['P1'].I">
      <div class="header">
        <h2>
          Seleccione la categoría en la que se encuentra <br/>
          para solicitar este beneficio:
        </h2>
      </div>
      <div class="body-p1">
        <ul class="thumbs-covid-19 primero">
          <li>
            <div class="card">
              <div class="text-center contenedor-card-beneficio">
                <a class="btn-beneficio" (click)="seleccionPerfil(textosCovid19.hogarVulnerable)">
                  <img src="./assets/img/covid19-hogar-vulnerable.png" alt="Hogar vulnerable con ficha RSH" />
                </a>
              </div>
            </div>
          </li>
          <li>
            <div class="card">
              <div class="text-center contenedor-card-beneficio">
                <a class="btn-beneficio" (click)="seleccionPerfil(textosCovid19.adultoMayor)">
                  <img src="./assets/img/covid19-adulto-mayor.png" alt="Adulto mayor de 60 años" />
                </a>
              </div>
            </div>
          </li>
          <li>
            <div class="card">
              <div class="text-center contenedor-card-beneficio">
                <a class="btn-beneficio" (click)="seleccionPerfil(textosCovid19.recibiendoSeguroDesempleo)">
                  <img src="./assets/img/covid19-seguro-desempleo.png" alt="Persona percibiendo seguro de desempleo" />
                </a>
              </div>
            </div>
          </li>
          <li>
            <div class="card">
              <div class="text-center contenedor-card-beneficio">
                <a class="btn-beneficio" (click)="seleccionPerfil(textosCovid19.suspensionReduccionJornada)">
                  <img src="./assets/img/covid19-reduccion-jornada.png" alt="Suspensión o reducción de jornada laboral" />
                </a>
              </div>
            </div>
          </li>
        </ul>
        <ul class="thumbs-covid-19 segundo">
          <li>
            <div class="card">
              <div class="text-center contenedor-card-beneficio">
                <a class="btn-beneficio" (click)="seleccionPerfil(textosCovid19.trabajadorIndependiente)">
                  <img src="./assets/img/covid19-trabajador-independiente.png" alt="Trabajador informal o independiente" />
                </a>
              </div>
            </div>
          </li>
          <li>
            <div class="card">
              <div class="text-center contenedor-card-beneficio">
                <a class="btn-beneficio" (click)="seleccionPerfil(textosCovid19.institucionesOrganizaciones)">
                  <img src="./assets/img/covid19-instituciones-organizaciones.png" alt="Instituciones, organizaciones sociales y microempresas" />
                </a>
              </div>
            </div>
          </li>
          <li>
            <div class="card">
              <div class="text-center contenedor-card-beneficio">
                <a class="btn-beneficio" (click)="seleccionPerfil(textosCovid19.otros)">
                  <img src="./assets/img/covid19-otros.png" alt="Otros perfiles de vulnerabilidad" />
                </a>
              </div>
            </div>
          </li>
        </ul>
        <div class="preguntas-frecuentes">
          <div class="calcule-valor-cuota">
            Calcule la cantidad y valor de cuota de su deuda <a href="http://wtx.metrogas.cl/mtgCalculadoraOnline/Home/Index" target="_blank">aquí</a>
          </div>
          <div class="header">
            <h3>Información importante</h3>
          </div>
          <div class="body">
            <ngb-accordion #acc="ngbAccordion" [destroyOnHide]="false" activeIds="config-panel-one">
              <ngb-panel id="pregunta-1">
                <ng-template ngbPanelTitle>
                  <div class="titulo">
                    <p class="numero">1</p>
                    <p class="texto">¿En qué consiste el beneficio de postergación de pagos por contingencia Covid-19?</p>
                    <div class="expande">
                      <label for="collapsible" class="lbl-toggle"></label>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    El beneficio consiste en que las deudas de gas, que se generen entre el 18 de marzo de 2020 y el 31 de diciembre de 2021, se pueden postergar,
                    para pagarse hasta en 48 cuotas iguales y sucesivas, sin ningún tipo de multas ni intereses.
                  </p>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="pregunta-2">
                <ng-template ngbPanelTitle>
                  <div class="titulo">
                    <p class="numero">2</p>
                    <p class="texto">Si tengo deuda previa, ¿me puedo acoger a este beneficio?</p>
                    <div class="expande">
                      <label for="collapsible" class="lbl-toggle"></label>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    Sí, puede acogerse a este beneficio, y podrá incluir la deuda previa de hasta 5 UF.
                  </p>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="pregunta-3">
                <ng-template ngbPanelTitle>
                  <div class="titulo">
                    <p class="numero">3</p>
                    <p class="texto">¿Qué pasa si mi deuda previa a la vigencia de este beneficio es mayor a las 5 UF?</p>
                    <div class="expande">
                      <label for="collapsible" class="lbl-toggle"></label>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    La deuda anterior mayor a 5 UF, no es parte del beneficio otorgado por la ley 21.249, no obstante usted puede realizar una solicitud
                    adjuntando los respaldos correspondientes para que Metrogas evalúe su situación en particular.
                  </p>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="pregunta-4">
                <ng-template ngbPanelTitle>
                  <div class="titulo">
                    <p class="numero">4</p>
                    <p class="texto">¿Qué pasa si yo ya solicité un plan de pago antes de la vigencia de este beneficio?</p>
                    <div class="expande">
                      <label for="collapsible" class="lbl-toggle"></label>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    El plan de pago se considera una deuda previa, por lo que puede solicitar este beneficio si la deuda previa no supera las 5 UF.
                    Si dicha deuda es mayor, aplica lo establecido en la pregunta número 2.
                  </p>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="pregunta-5">
                <ng-template ngbPanelTitle>
                  <div class="titulo">
                    <p class="numero">5</p>
                    <p class="texto">¿Quiénes pueden acceder a este beneficio?</p>
                    <div class="expande">
                      <label for="collapsible" class="lbl-toggle"></label>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    Este beneficio puede ser solicitado por los clientes residenciales finales que cumplan, a lo menos, con uno de los siguientes requisitos:
                  </p>
                  <p>
                    <strong>a)</strong> Pertenecer al 80% de hogares de mayor vulnerabilidad, de acuerdo al Registro Nacional de Hogares del Ministerio de Desarrollo Social.
                  </p>
                  <p>
                    <strong>b)</strong> Ser adulto mayor, es decir, tener más de 60 años de edad.
                  </p>
                  <p>
                    <strong>c)</strong> Estar recibiendo las prestaciones del Seguro de Cesantía de la Ley N°19.728.
                  </p>
                  <p>
                    <strong>d)</strong> Estar acogido a alguna de las causales establecidas en la Ley N°21.227 (Ley de Protección al empleo Covid-19), ya sea por la suspensión
                    de la relación laboral, o por una reducción temporal de jornada de trabajo; y acreditar condición que demuestre imposibilidad de pago de cuenta de gas.
                  </p>
                  <p>
                    <strong>e)</strong> Ser trabajador independiente o informal, y acreditar condición que demuestre que está siendo afectado por una disminución significativa
                    de ingresos que justifique la imposibilidad de pago de cuenta de gas.
                  </p>
                  <p>
                    <strong>f)</strong> Instituciones u organizaciones como hospitales y centro de salud, cárceles y centros penitenciarios, hogares de menores en riesgo social,
                    abandono o compromiso delictual, hogares de larga estadía de adultos mayores, bomberos, organización sin fines de lucro, y microempresas.
                  </p>
                  <p>
                    <strong>g)</strong> Otros usuarios finales que no se encuentren comprendidos en los numerales anteriores que acrediten estar imposibilitados de dar
                    cumplimiento a las obligaciones, con declaración jurada simple.
                  </p>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="pregunta-6">
                <ng-template ngbPanelTitle>
                  <div class="titulo">
                    <p class="numero">6</p>
                    <p class="texto">¿Cómo puedo solicitar el beneficio?</p>
                    <div class="expande">
                      <label for="collapsible" class="lbl-toggle"></label>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    Si cumple con alguno de los requisitos para acceder al beneficio y cuenta con la documentación requerida, debe solicitar el beneficio a través del
                    Centro de Ayuda Online de Metrogas, ingresando <a href="./beneficio-clientes-vulnerables-covid19">aquí</a> o llamando al 600 337 8000; de lunes a viernes de 9 a 19 horas, excepto festivos.
                  </p>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="pregunta-7">
                <ng-template ngbPanelTitle>
                  <div class="titulo">
                    <p class="numero">7</p>
                    <p class="texto">Otras preguntas frecuentes</p>
                    <div class="expande">
                      <label for="collapsible" class="lbl-toggle"></label>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      Si recibo el beneficio de postergación en el pago de cuentas, ¿cuándo comenzarán a cobrar las cuotas?
                    </p>
                    <p class="p-respuesta">
                      Las cuotas comenzarán a cobrarse a partir de enero de 2022.
                    </p>
                    <p class="p-respuesta">
                      Para obtener información sobre su deuda, requisitos y forma de acceder a los beneficios que otorga la Ley 21.249, consulte llamando al 600 337 8000;
                      de lunes a viernes de 9 a 19 horas, excepto festivos.
                    </p>
                  </div>

                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿Cuánto tiempo se demoran en contestar la solicitud de postergación de cobro de deudas?
                    </p>
                    <p class="p-respuesta">
                      Una vez ingresada la solicitud y entregada la documentación requerida, Metrogas tiene un plazo de 5 días hábiles para responder la solicitud.
                    </p>
                  </div>

                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿Qué ocurre si no puedo pagar una vez finalizado el plazo de postergación?
                    </p>
                    <p class="p-respuesta">
                      Terminado el plazo de postergación de pago, recibirá una boleta de gas que señalará el monto y fecha de vencimiento de la primera cuota sin
                      interés por la deuda postergada.  Si no realiza el pago, después de 2 meses y medio desde el vencimiento de la primera boleta emitida terminado
                      el plazo del beneficio, ingresará a corte en trámite.
                    </p>
                  </div>

                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿Por qué podrían rechazarme la solicitud?
                    </p>
                    <p class="p-respuesta">
                      Por no encontrarse en alguno de los beneficiarios señalados en la pregunta 5 anterior.
                    </p>
                  </div>

                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿Hasta cuándo puedo solicitar este beneficio?
                    </p>
                    <p class="p-respuesta">
                      El beneficio puede solicitarlo hasta las 23:59 horas del 31 de diciembre de 2021.
                    </p>
                  </div>

                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿Qué es una declaración jurada?
                    </p>
                    <p class="p-respuesta">
                      La Declaración Jurada Simple es un documento mediante el cual una persona realiza una declaración relativa a un hecho o entrega información respecto
                      del mismo, bajo la responsabilidad de que la información entregada es verdadera y fidedigna.
                    </p>
                    <p class="p-respuesta">
                      Esta puede ser manuscrita o impresa, y no requiere la firma de un notario público.
                    </p>
                  </div>

                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿Qué significa postergar el pago de la deuda?
                    </p>
                    <p class="p-respuesta">
                      Postergar el pago de la deuda es aplazar el pago del consumo de gas que se haya originado durante el período comprendido entre el 18 de marzo de 2020 y
                      el 31 de diciembre de 2021, pudiendo incluir, además, una deuda previa por hasta 5 UF.
                    </p>
                    <p class="p-respuesta">
                      No es un beneficio automático, por lo que debe ser solicitado por el cliente adjuntando la documentación que acredite que se encuentra en alguno de los casos
                      contemplados por la Ley N°21.249.
                    </p>
                  </div>

                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿Qué diferencia hay entre postergar y negociar una deuda?
                    </p>
                    <p class="p-respuesta">
                      Postergar es el beneficio que permite aplazar el pago de la deuda de cuenta de gas, sin multas ni intereses en el contexto de la contingencia por Covid-19
                      y de la Ley Postergación Cobro de Deudas. Por su parte, negociar es otro beneficio permanente que ofrece Metrogas, que permite acordar condiciones de pago,
                      tales como monto de pie y número de cuotas para pagar una deuda.
                    </p>
                  </div>
                </ng-template>
              </ngb-panel>
            </ngb-accordion>
          </div>
        </div>
        <div *ngIf="fechaSolicitud" class="solicitudes">
          <div class="header">
            <h3>Número de solicitudes aceptadas y rechazadas</h3>
          </div>
          <div class="body text-center">
            <div class="contenedor-solicitudes table-responsive center">
              <table class="tabla-solicitudes">
                <thead>
                  <tr class="borde-negro blue">
                    <td>
                    </td>
                    <td colspan="2" class="txt-negrita td-region">
                      TOTAL
                    </td>
                    <td colspan="2" class="txt-negrita td-region">
                      RM
                    </td>
                    <td colspan="2" class="txt-negrita td-region">
                      VI
                    </td>
                    <td colspan="2" class="txt-negrita td-region">
                      X
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr class="gray">
                    <td class="txt-left txt-negrita borde-negro-right">
                      N° Total de Solicitudes
                    </td>
                    <td class="txt-right td-region-50p">
                      {{ total_solicitudes }}
                    </td>
                    <td class="borde-negro-right td-region-50p"></td>
                    <td class="txt-right td-region-50p">
                      {{ total_solicitudes_rm }}
                    </td>
                    <td class="txt-right borde-negro-right td-region-50p">
                      <!--{{ porc_total_solicitudes_rm }}%-->
                    </td>
                    <td class="txt-right td-region-50p">
                      {{ total_solicitudes_ohi }}
                    </td>
                    <td class="txt-right borde-negro-right td-region-50p">
                      <!--{{ porc_total_solicitudes_ohi }}%-->
                    </td>
                    <td class="txt-right td-region-50p">
                      {{ total_solicitudes_lla }}
                    </td>
                    <td class="txt-right borde-negro-right td-region-50p">
                      <!--{{ porc_total_solicitudes_lla }}%-->
                    </td>
                  </tr>
                  <tr>
                    <td class="txt-left borde-negro-right">
                      Solicitudes Aprobadas
                    </td>
                    <td class="txt-right">
                      {{ solicitudes_aprobadas }}
                    </td>
                    <td class="txt-right borde-negro-right">
                      {{ porc_solicitudes_aprobadas }}%
                    </td>
                    <td class="txt-right">
                      {{ solicitudes_aprobadas_rm }}
                    </td>
                    <td class="txt-right borde-negro-right">
                      {{ porc_solicitudes_aprobadas_rm }}%
                    </td>
                    <td class="txt-right">
                      {{ solicitudes_aprobadas_ohi }}
                    </td>
                    <td class="txt-right borde-negro-right">
                      {{ porc_solicitudes_aprobadas_ohi }}%
                    </td>
                    <td class="txt-right">
                      {{ solicitudes_aprobadas_lla }}
                    </td>
                    <td class="txt-right borde-negro-right">
                      {{ porc_solicitudes_aprobadas_lla }}%
                    </td>
                  </tr>
                  <tr class="gray">
                    <td class="txt-left borde-negro-right">
                      Pendientes de Aprobación
                    </td>
                    <td class="txt-right">
                      {{ solicitudes_pendientes_aprobacion }}
                    </td>
                    <td class="txt-right borde-negro-right">
                      {{ porc_solicitudes_pendientes_aprobacion }}%
                    </td>
                    <td class="txt-right">
                      {{ solicitudes_pendientes_aprobacion_rm }}
                    </td>
                    <td class="txt-right borde-negro-right">
                      {{ porc_solicitudes_pendientes_aprobacion_rm }}%
                    </td>
                    <td class="txt-right">
                      {{ solicitudes_pendientes_aprobacion_ohi }}
                    </td>
                    <td class="txt-right borde-negro-right">
                      {{ porc_solicitudes_pendientes_aprobacion_ohi }}%
                    </td>
                    <td class="txt-right">
                      {{ solicitudes_pendientes_aprobacion_lla }}
                    </td>
                    <td class="txt-right borde-negro-right">
                      {{ porc_solicitudes_pendientes_aprobacion_lla }}%
                    </td>
                  </tr>
                  <tr>
                    <td class="txt-left borde-negro-right">
                      Rechazadas
                    </td>
                    <td class="txt-right">
                      {{ solicitudes_rechazadas }}
                    </td>
                    <td class="txt-right borde-negro-right">
                      {{ porc_solicitudes_rechazadas }}%
                    </td>
                    <td class="txt-right">
                      {{ solicitudes_rechazadas_rm }}
                    </td>
                    <td class="txt-right borde-negro-right">
                      {{ porc_solicitudes_rechazadas_rm }}%
                    </td>
                    <td class="txt-right">
                      {{ solicitudes_rechazadas_ohi }}
                    </td>
                    <td class="txt-right borde-negro-right">
                      {{ porc_solicitudes_rechazadas_ohi }}%
                    </td>
                    <td class="txt-right">
                      {{ solicitudes_rechazadas_lla }}
                    </td>
                    <td class="txt-right borde-negro-right">
                      {{ porc_solicitudes_rechazadas_lla }}%
                    </td>
                  </tr>
                  <tr class="gray">
                    <td class="txt-left borde-negro-right">
                      Solicitudes Desistidas
                    </td>
                    <td class="txt-right">
                      {{ solicitudes_desistidas }}
                    </td>
                    <td class="txt-right borde-negro-right">
                      {{ porc_solicitudes_desistidas }}%
                    </td>
                    <td class="txt-right">
                      {{ solicitudes_desistidas_rm }}
                    </td>
                    <td class="txt-right borde-negro-right">
                      {{ porc_solicitudes_desistidas_rm }}%
                    </td>
                    <td class="txt-right">
                      {{ solicitudes_desistidas_ohi }}
                    </td>
                    <td class="txt-right borde-negro-right">
                      {{ porc_solicitudes_desistidas_ohi }}%
                    </td>
                    <td class="txt-right">
                      {{ solicitudes_desistidas_lla }}
                    </td>
                    <td class="txt-right borde-negro-right">
                      {{ porc_solicitudes_desistidas_lla }}%
                    </td>
                  </tr>
                </tbody>
              </table>
              <p class="txt-negrita">
                Tasa de aprobación, considerando aprobados y rechazados:
                <span>{{ tasa_aprobacion }}%</span>
              </p>
              <p>
                Información actualizada al: {{ fechaSolicitud }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="callToAcction">
          <input type="button" value="VOLVER" class="btn btn-volver" [routerLink]="['/home']">
        </div>
      </div>
    </div>
    <!-- PASO NUMERO 2 -->
    <div class="paso-2" *ngIf="pasos[0]['P2'].I">
      <div class="header">
        <div class="ico">
          <img *ngIf="perfil==textosCovid19.hogarVulnerable" src="./assets/img/covid19-hogar-vulnerable.png" alt="Hogar vulnerable con ficha RSH">
          <img *ngIf="perfil==textosCovid19.adultoMayor" src="./assets/img/covid19-adulto-mayor.png" alt="Adulto mayor de 60 años">
          <img *ngIf="perfil==textosCovid19.recibiendoSeguroDesempleo" src="./assets/img/covid19-seguro-desempleo.png" alt="Persona percibiendo seguro de desempleo">
          <img *ngIf="perfil==textosCovid19.suspensionReduccionJornada" src="./assets/img/covid19-reduccion-jornada.png" alt="Suspensión o reducción de jornada laboral">
          <img *ngIf="perfil==textosCovid19.trabajadorIndependiente" src="./assets/img/covid19-trabajador-independiente.png" alt="Trabajador informal o indendiente">
          <img *ngIf="perfil==textosCovid19.institucionesOrganizaciones" src="./assets/img/covid19-instituciones-organizaciones.png" alt="Instituciones, organizaciones sociales y microempresas">
          <img *ngIf="perfil==textosCovid19.otros" src="./assets/img/covid19-otros.png" alt="Otros perfiles de vulnerabilidad">
        </div>
        <h2>
          Ha seleccionado la categoría {{ perfil }}:
        </h2>
        <p class="observacion-beneficio" *ngIf="perfil==textosCovid19.institucionesOrganizaciones">
          Esta categoría corresponde a instituciones u organizaciones como hospitales y centros de salud, cárceles y centros
          penitenciarios, hogares de menores en riesgo social, abandono o compromiso delictual, hogares de larga estadía
          de adultos mayores, bomberos, organización sin fines de lucro, y microempresas.
        </p>
        <p class="observacion-beneficio" *ngIf="perfil==textosCovid19.otros">
          Esta categoría corresponde a otros usuarios finales que no se encuentren comprendidos en los numerales anteriores
          que acrediten estar imposibilitados de dar cumplimiento a las obligaciones.
        </p>
        <p>
          Para solicitar este beneficio, primero debe reunir los siguientes documentos:
        </p>
      </div>
      <div class="body">
        <div *ngIf="perfil==textosCovid19.hogarVulnerable" class="info">
          <ul>
            <li>
              <p class="numero">1</p>
              <p class="titulo">Imagen de la cédula de identidad por ambos lados.</p>
            </li>
            <li>
              <p class="numero">2</p>
              <p class="titulo">Copia de ficha en Registro Social que demuestre que se encuentra en el 80% de hogares más vulnerables. Si no tiene este documento, obtenlo <a href="http://www.registrosocial.gob.cl/" target="_blank">aquí</a></p>
            </li>
          </ul>
        </div>

        <div *ngIf="perfil==textosCovid19.adultoMayor" class="info">
          <ul>
            <li>
              <p class="numero">1</p>
              <p class="titulo">Imagen de la cédula de identidad por ambos lados.</p>
            </li>
            <li>
              <p class="numero">2</p>
              <p class="titulo">Copia de documento que acredite residencia en el domicilio de la deuda (contrato de arriendo, escritura de propiedad, boletas de servicios de internet o celular).</p>
            </li>
          </ul>
        </div>

        <div *ngIf="perfil==textosCovid19.recibiendoSeguroDesempleo" class="info">
          <ul>
            <li>
              <p class="numero">1</p>
              <p class="titulo">Imagen de la cédula de identidad por ambos lados.</p>
            </li>
            <li>
              <p class="numero">2</p>
              <p class="titulo">Copia de documento que acredite residencia en el domicilio de la deuda (contrato de arriendo, escritura de propiedad, boletas de servicios de internet o celular).</p>
            </li>
            <li>
              <p class="numero">3</p>
              <p class="titulo">Comprobante de solicitud de activación seguro de cesantía o equivalente.</p>
            </li>
          </ul>
        </div>

        <div *ngIf="perfil==textosCovid19.suspensionReduccionJornada" class="info">
          <ul>
            <li>
              <p class="numero">1</p>
              <p class="titulo">Imagen de la cédula de identidad por ambos lados.</p>
            </li>
            <li>
              <p class="numero">2</p>
              <p class="titulo">Anexo de contrato de trabajo que acredite reducción o suspensión de relación laboral.</p>
            </li>
            <li>
              <p class="numero">3</p>
              <p class="titulo">Copia de documento que acredite residencia en el domicilio de la deuda (contrato de arriendo, escritura de propiedad, boletas de servicios de internet o celular).</p>
            </li>
          </ul>
        </div>

        <div *ngIf="perfil==textosCovid19.trabajadorIndependiente" class="info">
          <ul>
            <li>
              <p class="numero">1</p>
              <p class="titulo">Imagen de la cédula de identidad por ambos lados.</p>
            </li>
            <li>
              <p class="numero">2</p>
              <p class="titulo">Copia de documento que acredite residencia en el domicilio de la deuda (contrato de arriendo, escritura de propiedad, boletas de servicios de internet o celular).</p>
            </li>
            <li>
              <p class="numero">3</p>
              <p class="titulo">Declaración jurada simple que señale la situación que justifique la postergación del pago.</p>
            </li>
          </ul>
        </div>

        <div *ngIf="perfil==textosCovid19.institucionesOrganizaciones" class="info">
          <ul>
            <li>
              <p class="numero">1</p>
              <p class="titulo">Imagen de la cédula de identidad por ambos lados.</p>
            </li>
            <li>
              <p class="numero">2</p>
              <p class="titulo">Documento que acredite personería para representar la institución.</p>
            </li>
          </ul>
        </div>

        <div *ngIf="perfil==textosCovid19.otros" class="info">
          <ul>
            <li>
              <p class="numero">1</p>
              <p class="titulo">Imagen de la cédula de identidad por ambos lados.</p>
            </li>
            <li>
              <p class="numero">2</p>
              <p class="titulo">Copia de documento que acredite residencia en el domicilio de la deuda (contrato de arriendo, escritura de propiedad, boletas de servicios de internet o celular).</p>
            </li>
            <li>
              <p class="numero">3</p>
              <p class="titulo">Declaración jurada simple que señale la situación que justifique la postergación del pago.</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer">
        <div class="callToAcction">
          <div class="mitad">
            <input type="button" value="VOLVER" class="btn btn-volver-p2" (click)="gotoPaso(1)">
          </div>
          <div class="mitad text-right">
            <div class="info-continuar text-center">
              <p class="">Si ya tienes los documentos,<br/>presiona continuar</p>
              <input type="button" value="CONTINUAR" class="btn btn-continuar" (click)="gotoPaso(3)">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- PASO NUMERO 3 -->
    <div class="paso-3-beneficios" *ngIf="pasos[0]['P3'].I">
      <div class="header">
        <div class="ico">
          <img *ngIf="perfil==textosCovid19.hogarVulnerable" src="./assets/img/covid19-hogar-vulnerable.png" alt="Hogar vulnerable con ficha RSH">
          <img *ngIf="perfil==textosCovid19.adultoMayor" src="./assets/img/covid19-adulto-mayor.png" alt="Adulto mayor de 60 años">
          <img *ngIf="perfil==textosCovid19.recibiendoSeguroDesempleo" src="./assets/img/covid19-seguro-desempleo.png" alt="Persona percibiendo seguro de desempleo">
          <img *ngIf="perfil==textosCovid19.suspensionReduccionJornada" src="./assets/img/covid19-reduccion-jornada.png" alt="Suspensión o reducción de jornada laboral">
          <img *ngIf="perfil==textosCovid19.trabajadorIndependiente" src="./assets/img/covid19-trabajador-independiente.png" alt="Trabajador informal o indendiente">
          <img *ngIf="perfil==textosCovid19.institucionesOrganizaciones" src="./assets/img/covid19-instituciones-organizaciones.png" alt="Instituciones, organizaciones sociales y microempresas">
          <img *ngIf="perfil==textosCovid19.otros" src="./assets/img/covid19-otros.png" alt="Otros perfiles de vulnerabilidad">
        </div>
        <h2>
          Ha seleccionado la categoría {{ perfil }}:
        </h2>
        <p>
          Para continuar, complete estos datos:
        </p>
      </div>
      <div class="body">
        <form [formGroup]="formData">
          <div class="form">
            <div class="head">
              <h2>
                Identificación del solicitante
              </h2>
              <p class="txt-orange">
                (**datos obligatorios)
              </p>
            </div>
            <div class="body">
              <ul>
                <li *ngIf="perfil==textosCovid19.institucionesOrganizaciones">
                  <div class="box-campo-form">
                    <div class="ng-autocomplete">
                      <ng-select #tipoInstitucion
                                      [items]="dataTipoInstitucion"
                                      [selectOnTab]="true"
                                      bindValue="id_tipo_institucion"
                                      bindLabel="tipo_institucion"
                                      placeholder="**Tipo Institución"
                                      formControlName="tipoInstitucion"
                                      notFoundText="Tipo Institución no encontrado">
                      </ng-select>
                    </div>
                    <div class="error">
                      <div *ngIf="submitted && f.tipoInstitucion.errors">
                        <p *ngIf="f.tipoInstitucion.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.tipoInstitucion.errors.pattern">
                          tipo institución inválido
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <input type="text" placeholder="**Nombre y apellido" formControlName="nombre" [maxLength]="200" [ngClass]="{ 'is-invalid': submitted && f.nombre.errors }"/>
                    <div class="error">
                      <div *ngIf="submitted && f.nombre.errors">
                        <p *ngIf="f.nombre.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.nombre.errors.pattern">
                          nombre inválido
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <input type="text" placeholder="**Cédula de identidad" formControlName="rut" [maxLength]="12" [ngClass]="{ 'is-invalid': submitted && f.rut.errors }" (blur)="formatearRut($event)"/>
                    <div class="error">
                      <div *ngIf="submitted && f.rut.errors">
                        <p *ngIf="f.rut.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.rut.errors.maxlength || f.rut.errors.minlength || f.rut.errors?.rutValid">
                          rut inválido
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <input type="text" placeholder="**Teléfono de contacto" formControlName="telefono" [maxLength]="9" [ngClass]="{ 'is-invalid': submitted && f.telefono.errors }"/>
                    <div class="error">
                      <div *ngIf="submitted && f.telefono.errors">
                        <p *ngIf="f.telefono.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.telefono.errors.maxlength || f.telefono.errors.pattern">
                          teléfono inválido
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <input type="email" placeholder="**Correo electrónico" formControlName="email" [maxLength]="200" [ngClass]="{ 'is-invalid': submitted && f.email.errors }"/>
                    <div class="error">
                      <div *ngIf="submitted && f.email.errors">
                        <p *ngIf="f.email.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.email.errors.email || f.email.errors.maxlength">
                          email inválido
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="form">
            <div class="head">
              <h2>
                Datos del domicilio
              </h2>
            </div>
            <div class="body">
              <ul>
                <li>
                  <div class="box-campo-form">
                    <div class="cont-numero-cliente">
                      <input type="text" placeholder="**Número de cliente" [maxLength]="9" formControlName="nCliente" [ngClass]="{ 'is-invalid': submitted && f.nCliente.errors }"/>
                      <div class="div-numero-cliente">
                        <a style="cursor: pointer;" (click)="mostrarNumeroCliente()">
                          <img class="info-numero-cliente" src="./assets/img/info-icon.png" alt="Información número de cliente">
                        </a>
                      </div>
                      <div class="error">
                        <div *ngIf="submitted && f.nCliente.errors">
                          <p *ngIf="f.nCliente.errors.required">
                            dato obligatorio
                          </p>
                          <p *ngIf="f.nCliente.errors.maxlength || f.nCliente.errors.pattern || f.nCliente.errors.numClienteValid">
                            número de cliente inválido
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <input type="text" placeholder="**Dirección" formControlName="direccion" [maxLength]="200" [ngClass]="{ 'is-invalid': submitted && f.direccion.errors }"/>

                    <!--<ng-select #direccion
                                      [items]="dataDirecciones"
                                      [selectOnTab]="true"
                                      bindValue="direccion"
                                      bindLabel="direccion"
                                      placeholder="**Dirección"
                                      formControlName="direccion"
                                      [editableSearchTerm] = "true"
                                      notFoundText="Dirección no encontrada"
                                      (search)="obtenerDirecciones($event)"
                                      (change)="onChangeDireccion($event)">
                      </ng-select>-->

                    <div class="error">
                      <div *ngIf="submitted && f.direccion.errors">
                        <p *ngIf="f.direccion.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.direccion.errors.pattern">
                          dirección inválida
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <div class="ng-autocomplete">
                      <ng-select #region
                                      [items]="dataRegion"
                                      [selectOnTab]="true"
                                      bindValue="id_region"
                                      bindLabel="nombre_region"
                                      placeholder="**Región"
                                      formControlName="region"
                                      notFoundText="Región no encontrada"
                                      >
                      </ng-select>
                    </div>
                    <div class="error">
                      <div *ngIf="submitted && f.region.errors">
                        <p *ngIf="f.region.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.region.errors.pattern">
                          región inválida
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <div class="ng-autocomplete">
                      <ng-select #comunaOk
                                      [items]="dataComuna"
                                      [selectOnTab]="true"
                                      bindValue="id_comuna"
                                      bindLabel="nombre_comuna"
                                      placeholder="**Comuna"
                                      formControlName="comuna"
                                      notFoundText="Comuna no encontrada">
                      </ng-select>
                    </div>
                    <div class="error">
                      <div *ngIf="submitted && f.comuna.errors">
                        <p *ngIf="f.comuna.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.comuna.errors.pattern">
                          comuna inválida
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="form" *ngIf="perfil==textosCovid19.otros">
            <div class="head">
              <h2>
                Detalle situación que le imposibilita el pago (máx. 600 caracteres)
              </h2>
            </div>
            <div class="body">
              <ul>
                <li>
                  <div class="box-campo-form">
                    <textarea formControlName="detalleSituacion" placeholder="**Detalle situación" [maxLength]="600" [ngClass]="{ 'is-invalid': submitted && f.detalleSituacion.errors }"></textarea>
                    <div class="error">
                      <div *ngIf="submitted && f.detalleSituacion.errors">
                        <p *ngIf="f.detalleSituacion.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.detalleSituacion.errors.maxlength || f.detalleSituacion.errors.pattern">
                          detalle situación con caracteres inválidos
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="form">
            <div class="head">
              <h2>
                Seleccione el número de cuotas para pagar deuda
              </h2>
            </div>
            <div class="body">
              <ul>
                <li>
                  <div class="box-campo-form">
                    <ng-select #numeroCuotas
                                      [items]="dataCuotas"
                                      [selectOnTab]="true"
                                      bindValue="id"
                                      bindLabel="valor"
                                      placeholder="**Número de cuotas"
                                      formControlName="numeroCuotas"
                                      notFoundText="cantidad de cuotas válidas, de 1 a 12 cuotas">
                      </ng-select>
                    <div class="error">
                      <div *ngIf="submitted && f.numeroCuotas.errors">
                        <p *ngIf="f.numeroCuotas.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.numeroCuotas.errors.min || f.numeroCuotas.errors.max">
                          cantidad de cuotas válidas, de 1 a 12 cuotas
                        </p>
                      </div>
                    </div>
                    <div class="calcule-valor-cuota-dos">
                      Calcule la cantidad y valor de cuota de su deuda <a href="http://wtx.metrogas.cl/mtgCalculadoraOnline/Home/Index" target="_blank">aquí</a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="form">
            <div class="head">
              <h2>
                Adjuntar los siguientes archivos:
              </h2>
              <p class="txt-orange">
                (datos obligatorios)
              </p>
            </div>
            <div class="tips-archivos">
              <p>
                Recomendamos utilizar archivos jpg, pdf y Word, de peso máximo 5 MB.
              </p>
            </div>
            <div class="body">
              <ul class="uploadFile">
                <li *ngIf="perfil==textosCovid19.hogarVulnerable || perfil === textosCovid19.adultoMayor || perfil==textosCovid19.recibiendoSeguroDesempleo || perfil==textosCovid19.suspensionReduccionJornada || perfil==textosCovid19.trabajadorIndependiente || perfil==textosCovid19.institucionesOrganizaciones || perfil==textosCovid19.otros">
                  <div class="tipoFile">
                    <p>Cédula de identidad <br/>solicitante (frontal)
                      <span class="error">
                        <span *ngIf="submitted && f.fileRutSol.errors && f.fileRutSol.errors.required">
                          <br>archivo requerido
                        </span>
                        <span *ngIf="submitted && f.fileRutSol.errors && f.fileRutSol.errors.requiredFileType">
                          <br>archivo no válido
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="campo">
                    <label for="fileRutSol" class="custom-file-input"></label>
                    <input type="file" class="custom-file-input hidden" name="fileRutSol" id="fileRutSol" formControlName="fileRutSol" accept="{{mimeTypes}}" (change)="fileRutSolProgress($event)">
                  </div>
                  <div class="aciones">
                    <ul>
                      <li>
                        <img src="./assets/img/check-0.png" alt ="Archivo no cargado" *ngIf="!infoMessageRutSol && !errorInfoMessageRutSol">
                        <img src="./assets/img/check-1.png" alt ="Archivo cargado" *ngIf="infoMessageRutSol">
                        <img src="./assets/img/error.png" alt="Archivo cargado con error" *ngIf="errorInfoMessageRutSol" title="{{errorInfoMessageRutSol}}">
                      </li>
                      <li>
                        <img src="./assets/img/ver-0.png" alt="Ver archivo" *ngIf="!infoMessageRutSol">
                        <img src="./assets/img/ver-1.png" alt="Ver archivo" *ngIf="infoMessageRutSol" (click)="lightboxFile(1)">
                      </li>
                      <li>
                        <img src="./assets/img/delete-0.png" alt="Eliminar archivo" (click)="eliminarArchivo(1, 'fileRutSol')">
                      </li>
                    </ul>
                  </div>
                </li>

                <li *ngIf="perfil==textosCovid19.hogarVulnerable || perfil === textosCovid19.adultoMayor || perfil==textosCovid19.recibiendoSeguroDesempleo || perfil==textosCovid19.suspensionReduccionJornada || perfil==textosCovid19.trabajadorIndependiente || perfil==textosCovid19.institucionesOrganizaciones || perfil==textosCovid19.otros">
                  <div class="tipoFile">
                    <p>Cédula de identidad <br/>solicitante (reverso)
                      <span class="error">
                        <span *ngIf="submitted && f.fileRutSolReverso.errors && f.fileRutSolReverso.errors.required">
                          <br>archivo requerido
                        </span>
                        <span *ngIf="submitted && f.fileRutSolReverso.errors && f.fileRutSolReverso.errors.requiredFileType">
                          <br>archivo no válido
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="campo">
                    <label for="fileRutSolReverso" class="custom-file-input"></label>
                    <input type="file" class="custom-file-input hidden" name="fileRutSolReverso" id="fileRutSolReverso" formControlName="fileRutSolReverso" accept="{{mimeTypes}}" (change)="fileRutSolReversoProgress($event)">
                  </div>
                  <div class="aciones">
                    <ul>
                      <li>
                        <img src="./assets/img/check-0.png" alt ="Archivo no cargado" *ngIf="!infoMessageRutSolReverso && !errorInfoMessageRutSolReverso">
                        <img src="./assets/img/check-1.png" alt ="Archivo cargado" *ngIf="infoMessageRutSolReverso">
                        <img src="./assets/img/error.png" alt="Archivo cargado con error" *ngIf="errorInfoMessageRutSolReverso" title="{{errorInfoMessageRutSolReverso}}">
                      </li>
                      <li>
                        <img src="./assets/img/ver-0.png" alt="Ver archivo" *ngIf="!infoMessageRutSolReverso">
                        <img src="./assets/img/ver-1.png" alt="Ver archivo" *ngIf="infoMessageRutSolReverso" (click)="lightboxFile(13)">
                      </li>
                      <li>
                        <img src="./assets/img/delete-0.png" alt="Eliminar archivo" (click)="eliminarArchivo(13, 'fileRutSolReverso')">
                      </li>
                    </ul>
                  </div>
                </li>

                <!--<li *ngIf="perfil==textosCovid19.recibiendoSeguroDesempleo">
                  <div class="tipoFile">
                    <p>Copia finiquito de contrato o <br/>
                      carta aviso de despido
                      <span class="error">
                        <span *ngIf="submitted && f.fileFiniquitoCartaDespido.errors && f.fileFiniquitoCartaDespido.errors.required">
                          <br>archivo requerido
                        </span>
                        <span *ngIf="submitted && f.fileFiniquitoCartaDespido.errors && f.fileFiniquitoCartaDespido.errors.requiredFileType">
                          <br>archivo no válido
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="campo">
                    <label for="fileFiniquitoCartaDespido" class="custom-file-input"></label>
                    <input type="file" class="custom-file-input hidden" name="fileFiniquitoCartaDespido" id="fileFiniquitoCartaDespido" formControlName="fileFiniquitoCartaDespido" accept="{{mimeTypes}}" (change)="fileFiniquitoCartaDespidoProgress($event)">
                  </div>
                  <div class="aciones">
                    <ul>
                      <li>
                        <img src="./assets/img/check-0.png" alt ="Archivo no cargado" *ngIf="!infoMessageFiniquitoCartaDespido && !errorInfoMessageFiniquitoCartaDespido">
                        <img src="./assets/img/check-1.png" alt ="Archivo cargado" *ngIf="infoMessageFiniquitoCartaDespido">
                        <img src="./assets/img/error.png" alt="Archivo cargado con error" *ngIf="errorInfoMessageFiniquitoCartaDespido" title="{{errorInfoMessageFiniquitoCartaDespido}}">
                      </li>
                      <li>
                        <img src="./assets/img/ver-0.png" alt="Ver archivo" *ngIf="!infoMessageFiniquitoCartaDespido">
                        <img src="./assets/img/ver-1.png" alt="Ver archivo" *ngIf="infoMessageFiniquitoCartaDespido" (click)="lightboxFile(9)">
                      </li>
                      <li>
                        <img src="./assets/img/delete-0.png" alt="Eliminar archivo" (click)="eliminarArchivo(9, 'fileFiniquitoCartaDespido')">
                      </li>
                    </ul>
                  </div>
                </li>-->

                <li *ngIf="perfil==textosCovid19.suspensionReduccionJornada">
                  <div class="tipoFile">
                    <p>Anexo de contrato reducción o <br/>
                      suspensión de jornada laboral
                      <span class="error">
                        <span *ngIf="submitted && f.fileAnexoContrato.errors && f.fileAnexoContrato.errors.required">
                          <br>archivo requerido
                        </span>
                        <span *ngIf="submitted && f.fileAnexoContrato.errors && f.fileAnexoContrato.errors.requiredFileType">
                          <br>archivo no válido
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="campo">
                    <label for="fileAnexoContrato" class="custom-file-input"></label>
                    <input type="file" class="custom-file-input hidden" name="fileAnexoContrato" id="fileAnexoContrato" formControlName="fileAnexoContrato" accept="{{mimeTypes}}" (change)="fileAnexoContratoProgress($event)">
                  </div>
                  <div class="aciones">
                    <ul>
                      <li>
                        <img src="./assets/img/check-0.png" alt ="Archivo no cargado" *ngIf="!infoMessageAnexoContrato && !errorInfoMessageAnexoContrato">
                        <img src="./assets/img/check-1.png" alt ="Archivo cargado" *ngIf="infoMessageAnexoContrato">
                        <img src="./assets/img/error.png" alt="Archivo cargado con error" *ngIf="errorInfoMessageAnexoContrato" title="{{errorInfoMessageAnexoContrato}}">
                      </li>
                      <li>
                        <img src="./assets/img/ver-0.png" alt="Ver archivo" *ngIf="!infoMessageAnexoContrato">
                        <img src="./assets/img/ver-1.png" alt="Ver archivo" *ngIf="infoMessageAnexoContrato" (click)="lightboxFile(5)">
                      </li>
                      <li>
                        <img src="./assets/img/delete-0.png" alt="Eliminar archivo" (click)="eliminarArchivo(5, 'fileAnexoContrato')">
                      </li>
                    </ul>
                  </div>
                </li>

                <li *ngIf="perfil==textosCovid19.adultoMayor || perfil==textosCovid19.recibiendoSeguroDesempleo || perfil==textosCovid19.suspensionReduccionJornada || perfil==textosCovid19.trabajadorIndependiente || perfil==textosCovid19.otros">
                  <div class="tipoFile">
                    <p>Acreditación de residencia <br/>
                      en el domicilio
                      <span class="error">
                        <span *ngIf="submitted && f.fileAcreditacionResidencia.errors && f.fileAcreditacionResidencia.errors.required">
                          <br>archivo requerido
                        </span>
                        <span *ngIf="submitted && f.fileAcreditacionResidencia.errors && f.fileAcreditacionResidencia.errors.requiredFileType">
                          <br>archivo no válido
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="campo">
                    <label for="fileAcreditacionResidencia" class="custom-file-input"></label>
                    <input type="file" class="custom-file-input hidden" name="fileAcreditacionResidencia" id="fileAcreditacionResidencia" formControlName="fileAcreditacionResidencia" accept="{{mimeTypes}}" (change)="fileAcreditacionResidenciaProgress($event)">
                  </div>
                  <div class="aciones">
                    <ul>
                      <li>
                        <img src="./assets/img/check-0.png" alt ="Archivo no cargado" *ngIf="!infoMessageAcreditacionResidencia && !errorInfoMessageAcreditacionResidencia">
                        <img src="./assets/img/check-1.png" alt ="Archivo cargado" *ngIf="infoMessageAcreditacionResidencia">
                        <img src="./assets/img/error.png" alt="Archivo cargado con error" *ngIf="errorInfoMessageAcreditacionResidencia" title="{{errorInfoMessageAcreditacionResidencia}}">
                      </li>
                      <li>
                        <img src="./assets/img/ver-0.png" alt="Ver archivo" *ngIf="!infoMessageAcreditacionResidencia">
                        <img src="./assets/img/ver-1.png" alt="Ver archivo" *ngIf="infoMessageAcreditacionResidencia" (click)="lightboxFile(3)">
                      </li>
                      <li>
                        <img src="./assets/img/delete-0.png" alt="Eliminar archivo" (click)="eliminarArchivo(3, 'fileAcreditacionResidencia')">
                      </li>
                    </ul>
                  </div>
                </li>

                <li *ngIf="perfil==textosCovid19.recibiendoSeguroDesempleo">
                  <div class="tipoFile">
                    <p>Comprobante de solicitud activación <br/>
                      seguro de cesantía
                      <span class="error">
                        <span *ngIf="submitted && f.fileActivacionSeguroCesantia.errors && f.fileActivacionSeguroCesantia.errors.required">
                          <br>archivo requerido
                        </span>
                        <span *ngIf="submitted && f.fileActivacionSeguroCesantia.errors && f.fileActivacionSeguroCesantia.errors.requiredFileType">
                          <br>archivo no válido
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="campo">
                    <label for="fileActivacionSeguroCesantia" class="custom-file-input"></label>
                    <input type="file" class="custom-file-input hidden" name="fileActivacionSeguroCesantia" id="fileActivacionSeguroCesantia" formControlName="fileActivacionSeguroCesantia" accept="{{mimeTypes}}" (change)="fileActivacionSeguroCesantiaProgress($event)">
                  </div>
                  <div class="aciones">
                    <ul>
                      <li>
                        <img src="./assets/img/check-0.png" alt ="Archivo no cargado" *ngIf="!infoMessageActivacionSeguroCesantia && !errorInfoMessageActivacionSeguroCesantia">
                        <img src="./assets/img/check-1.png" alt ="Archivo cargado" *ngIf="infoMessageActivacionSeguroCesantia">
                        <img src="./assets/img/error.png" alt="Archivo cargado con error" *ngIf="errorInfoMessageActivacionSeguroCesantia" title="{{errorInfoMessageActivacionSeguroCesantia}}">
                      </li>
                      <li>
                        <img src="./assets/img/ver-0.png" alt="Ver archivo" *ngIf="!infoMessageActivacionSeguroCesantia">
                        <img src="./assets/img/ver-1.png" alt="Ver archivo" *ngIf="infoMessageActivacionSeguroCesantia" (click)="lightboxFile(4)">
                      </li>
                      <li>
                        <img src="./assets/img/delete-0.png" alt="Eliminar archivo" (click)="eliminarArchivo(4, 'fileActivacionSeguroCesantia')">
                      </li>
                    </ul>
                  </div>
                </li>

                <!--<li *ngIf="perfil==textosCovid19.otros">
                  <div class="tipoFile">
                    <p>Exposición fundada de la situación que justifique la solicitud <br/>
                      y antecedentes documentales que la respaldan
                      <span class="error">
                        <span *ngIf="submitted && f.fileExposicionFundadaSolicitud.errors && f.fileExposicionFundadaSolicitud.errors.required">
                          <br>archivo requerido
                        </span>
                        <span *ngIf="submitted && f.fileExposicionFundadaSolicitud.errors && f.fileExposicionFundadaSolicitud.errors.requiredFileType">
                          <br>archivo no válido
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="campo">
                    <label for="fileExposicionFundadaSolicitud" class="custom-file-input"></label>
                    <input type="file" class="custom-file-input hidden" name="fileExposicionFundadaSolicitud" id="fileExposicionFundadaSolicitud" formControlName="fileExposicionFundadaSolicitud" accept="{{mimeTypes}}" (change)="fileExposicionFundadaSolicitudProgress($event)">
                  </div>
                  <div class="aciones">
                    <ul>
                      <li>
                        <img src="./assets/img/check-0.png" alt ="Archivo no cargado" *ngIf="!infoMessageExposicionFundadaSolicitud && !errorInfoMessageExposicionFundadaSolicitud">
                        <img src="./assets/img/check-1.png" alt ="Archivo cargado" *ngIf="infoMessageExposicionFundadaSolicitud">
                        <img src="./assets/img/error.png" alt="Archivo cargado con error" *ngIf="errorInfoMessageExposicionFundadaSolicitud" title="{{errorInfoMessageExposicionFundadaSolicitud}}">
                      </li>
                      <li>
                        <img src="./assets/img/ver-0.png" alt="Ver archivo" *ngIf="!infoMessageExposicionFundadaSolicitud">
                        <img src="./assets/img/ver-1.png" alt="Ver archivo" *ngIf="infoMessageExposicionFundadaSolicitud" (click)="lightboxFile(11)">
                      </li>
                      <li>
                        <img src="./assets/img/delete-0.png" alt="Eliminar archivo" (click)="eliminarArchivo(11, 'fileExposicionFundadaSolicitud')">
                      </li>
                    </ul>
                  </div>
                </li>-->

                <li *ngIf="perfil==textosCovid19.hogarVulnerable">
                  <div class="tipoFile">
                    <p>Ficha registro social <br/>
                      de hogares
                      <span class="error">
                        <span *ngIf="submitted && f.fileRegistroSocialHogares.errors && f.fileRegistroSocialHogares.errors.required">
                          <br>archivo requerido
                        </span>
                        <span *ngIf="submitted && f.fileRegistroSocialHogares.errors && f.fileRegistroSocialHogares.errors.requiredFileType">
                          <br>archivo no válido
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="campo">
                    <label for="fileRegistroSocialHogares" class="custom-file-input"></label>
                    <input type="file" class="custom-file-input hidden" name="fileRegistroSocialHogares" id="fileRegistroSocialHogares" formControlName="fileRegistroSocialHogares" accept="{{mimeTypes}}" (change)="fileRegistroSocialHogaresProgress($event)">
                  </div>
                  <div class="aciones">
                    <ul>
                      <li>
                        <img src="./assets/img/check-0.png" alt ="Archivo no cargado" *ngIf="!infoMessageRegistroSocialHogares && !errorInfoMessageRegistroSocialHogares">
                        <img src="./assets/img/check-1.png" alt ="Archivo cargado" *ngIf="infoMessageRegistroSocialHogares">
                        <img src="./assets/img/error.png" alt="Archivo cargado con error" *ngIf="errorInfoMessageRegistroSocialHogares" title="{{errorInfoMessageRegistroSocialHogares}}">
                      </li>
                      <li>
                        <img src="./assets/img/ver-0.png" alt="Ver archivo" *ngIf="!infoMessageRegistroSocialHogares">
                        <img src="./assets/img/ver-1.png" alt="Ver archivo" *ngIf="infoMessageRegistroSocialHogares" (click)="lightboxFile(2)">
                      </li>
                      <li>
                        <img src="./assets/img/delete-0.png" alt="Eliminar archivo" (click)="eliminarArchivo(2, 'fileRegistroSocialHogares')">
                      </li>
                    </ul>
                  </div>
                </li>

                <!--<li *ngIf="perfil==textosCovid19.trabajadorIndependiente">
                  <div class="tipoFile">
                    <p>Documento certifique calidad <br/>
                      de trabajador independiente
                      <span class="error">
                        <span *ngIf="submitted && f.fileCertificadoTrabajadorIndependiente.errors && f.fileCertificadoTrabajadorIndependiente.errors.required">
                          <br>archivo requerido
                        </span>
                        <span *ngIf="submitted && f.fileCertificadoTrabajadorIndependiente.errors && f.fileCertificadoTrabajadorIndependiente.errors.requiredFileType">
                          <br>archivo no válido
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="campo">
                    <label for="fileCertificadoTrabajadorIndependiente" class="custom-file-input"></label>
                    <input type="file" class="custom-file-input hidden" name="fileCertificadoTrabajadorIndependiente" id="fileCertificadoTrabajadorIndependiente" formControlName="fileCertificadoTrabajadorIndependiente" accept="{{mimeTypes}}" (change)="fileCertificadoTrabajadorIndependienteProgress($event)">
                  </div>
                  <div class="aciones">
                    <ul>
                      <li>
                        <img src="./assets/img/check-0.png" alt ="Archivo no cargado" *ngIf="!infoMessageCertificadoTrabajadorIndependiente && !errorInfoMessageCertificadoTrabajadorIndependiente">
                        <img src="./assets/img/check-1.png" alt ="Archivo cargado" *ngIf="infoMessageCertificadoTrabajadorIndependiente">
                        <img src="./assets/img/error.png" alt="Archivo cargado con error" *ngIf="errorInfoMessageCertificadoTrabajadorIndependiente" title="{{errorInfoMessageCertificadoTrabajadorIndependiente}}">
                      </li>
                      <li>
                        <img src="./assets/img/ver-0.png" alt="Ver archivo" *ngIf="!infoMessageCertificadoTrabajadorIndependiente">
                        <img src="./assets/img/ver-1.png" alt="Ver archivo" *ngIf="infoMessageCertificadoTrabajadorIndependiente" (click)="lightboxFile(6)">
                      </li>
                      <li>
                        <img src="./assets/img/delete-0.png" alt="Eliminar archivo" (click)="eliminarArchivo(6, 'fileCertificadoTrabajadorIndependiente')">
                      </li>
                    </ul>
                  </div>
                </li>-->

                <!--<li *ngIf="perfil==textosCovid19.otros">
                  <div class="tipoFile">
                    <p>Documento acredite <br/>
                      imposibilidad de pago
                      <span class="error">
                        <span *ngIf="submitted && f.fileImposibilidadPago.errors && f.fileImposibilidadPago.errors.required">
                          <br>archivo requerido
                        </span>
                        <span *ngIf="submitted && f.fileImposibilidadPago.errors && f.fileImposibilidadPago.errors.requiredFileType">
                          <br>archivo no válido
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="campo">
                    <label for="fileImposibilidadPago" class="custom-file-input"></label>
                    <input type="file" class="custom-file-input hidden" name="fileImposibilidadPago" id="fileImposibilidadPago" formControlName="fileImposibilidadPago" accept="{{mimeTypes}}" (change)="fileImposibilidadPagoProgress($event)">
                  </div>
                  <div class="aciones">
                    <ul>
                      <li>
                        <img src="./assets/img/check-0.png" alt ="Archivo no cargado" *ngIf="!infoMessageImposibilidadPago && !errorInfoMessageImposibilidadPago">
                        <img src="./assets/img/check-1.png" alt ="Archivo cargado" *ngIf="infoMessageImposibilidadPago">
                        <img src="./assets/img/error.png" alt="Archivo cargado con error" *ngIf="errorInfoMessageImposibilidadPago" title="{{errorInfoMessageImposibilidadPago}}">
                      </li>
                      <li>
                        <img src="./assets/img/ver-0.png" alt="Ver archivo" *ngIf="!infoMessageImposibilidadPago">
                        <img src="./assets/img/ver-1.png" alt="Ver archivo" *ngIf="infoMessageImposibilidadPago" (click)="lightboxFile(7)">
                      </li>
                      <li>
                        <img src="./assets/img/delete-0.png" alt="Eliminar archivo" (click)="eliminarArchivo(7, 'fileImposibilidadPago')">
                      </li>
                    </ul>
                  </div>
                </li>-->
                <!--<li *ngIf="perfil==textosCovid19.otros">
                  <div class="tipoFile">
                    <p>Información adicional que acredite <br/>
                      situación de vulnerabilidad
                      <span class="error">
                        <span *ngIf="submitted && f.fileSituacionVulnerabilidad.errors && f.fileSituacionVulnerabilidad.errors.required">
                          <br>archivo requerido
                        </span>
                        <span *ngIf="submitted && f.fileSituacionVulnerabilidad.errors && f.fileSituacionVulnerabilidad.errors.requiredFileType">
                          <br>archivo no válido
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="campo">
                    <label for="fileSituacionVulnerabilidad" class="custom-file-input"></label>
                    <input type="file" class="custom-file-input hidden" name="fileSituacionVulnerabilidad" id="fileSituacionVulnerabilidad" formControlName="fileSituacionVulnerabilidad" accept="{{mimeTypes}}" (change)="fileSituacionVulnerabilidadProgress($event)">
                  </div>
                  <div class="aciones">
                    <ul>
                      <li>
                        <img src="./assets/img/check-0.png" alt ="Archivo no cargado" *ngIf="!infoMessageSituacionVulnerabilidad && !errorInfoMessageSituacionVulnerabilidad">
                        <img src="./assets/img/check-1.png" alt ="Archivo cargado" *ngIf="infoMessageSituacionVulnerabilidad">
                        <img src="./assets/img/error.png" alt="Archivo cargado con error" *ngIf="errorInfoMessageSituacionVulnerabilidad" title="{{errorInfoMessageSituacionVulnerabilidad}}">
                      </li>
                      <li>
                        <img src="./assets/img/ver-0.png" alt="Ver archivo" *ngIf="!infoMessageSituacionVulnerabilidad">
                        <img src="./assets/img/ver-1.png" alt="Ver archivo" *ngIf="infoMessageSituacionVulnerabilidad" (click)="lightboxFile(8)">
                      </li>
                      <li>
                        <img src="./assets/img/delete-0.png" alt="Eliminar archivo" (click)="eliminarArchivo(8, 'fileSituacionVulnerabilidad')">
                      </li>
                    </ul>
                  </div>
                </li>-->

                <li *ngIf="perfil==textosCovid19.otros || perfil==textosCovid19.trabajadorIndependiente">
                  <div class="tipoFile">
                    <p>Declaración jurada simple que señale la situación <br/>
                      que justifique la postergación del pago
                      <span class="error">
                        <span *ngIf="submitted && f.fileDeclaracionJuradaSimple.errors && f.fileDeclaracionJuradaSimple.errors.required">
                          <br>archivo requerido
                        </span>
                        <span *ngIf="submitted && f.fileDeclaracionJuradaSimple.errors && f.fileDeclaracionJuradaSimple.errors.requiredFileType">
                          <br>archivo no válido
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="campo">
                    <label for="fileDeclaracionJuradaSimple" class="custom-file-input"></label>
                    <input type="file" class="custom-file-input hidden" name="fileDeclaracionJuradaSimple" id="fileDeclaracionJuradaSimple" formControlName="fileDeclaracionJuradaSimple" accept="{{mimeTypes}}" (change)="fileDeclaracionJuradaSimpleProgress($event)">
                  </div>
                  <div class="aciones">
                    <ul>
                      <li>
                        <img src="./assets/img/check-0.png" alt ="Archivo no cargado" *ngIf="!infoMessageDeclaracionJuradaSimple && !errorInfoMessageDeclaracionJuradaSimple">
                        <img src="./assets/img/check-1.png" alt ="Archivo cargado" *ngIf="infoMessageDeclaracionJuradaSimple">
                        <img src="./assets/img/error.png" alt="Archivo cargado con error" *ngIf="errorInfoMessageDeclaracionJuradaSimple" title="{{errorInfoMessageDeclaracionJuradaSimple}}">
                      </li>
                      <li>
                        <img src="./assets/img/ver-0.png" alt="Ver archivo" *ngIf="!infoMessageDeclaracionJuradaSimple">
                        <img src="./assets/img/ver-1.png" alt="Ver archivo" *ngIf="infoMessageDeclaracionJuradaSimple" (click)="lightboxFile(10)">
                      </li>
                      <li>
                        <img src="./assets/img/delete-0.png" alt="Eliminar archivo" (click)="eliminarArchivo(10, 'fileDeclaracionJuradaSimple')">
                      </li>
                    </ul>
                  </div>
                </li>

                <li *ngIf="perfil==textosCovid19.institucionesOrganizaciones">
                  <div class="tipoFile">
                    <p>Documento que acredite personería <br/>
                      para representar la institución
                      <span class="error">
                        <span *ngIf="submitted && f.filePersoneria.errors && f.filePersoneria.errors.required">
                          <br>archivo requerido
                        </span>
                        <span *ngIf="submitted && f.filePersoneria.errors && f.filePersoneria.errors.requiredFileType">
                          <br>archivo no válido
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="campo">
                    <label for="filePersoneria" class="custom-file-input"></label>
                    <input type="file" class="custom-file-input hidden" name="filePersoneria" id="filePersoneria" formControlName="filePersoneria" accept="{{mimeTypes}}" (change)="filePersoneriaProgress($event)">
                  </div>
                  <div class="aciones">
                    <ul>
                      <li>
                        <img src="./assets/img/check-0.png" alt ="Archivo no cargado" *ngIf="!infoMessagePersoneria && !errorInfoMessagePersoneria">
                        <img src="./assets/img/check-1.png" alt ="Archivo cargado" *ngIf="infoMessagePersoneria">
                        <img src="./assets/img/error.png" alt="Archivo cargado con error" *ngIf="errorInfoMessagePersoneria" title="{{errorInfoMessagePersoneria}}">
                      </li>
                      <li>
                        <img src="./assets/img/ver-0.png" alt="Ver archivo" *ngIf="!infoMessagePersoneria">
                        <img src="./assets/img/ver-1.png" alt="Ver archivo" *ngIf="infoMessagePersoneria" (click)="lightboxFile(12)">
                      </li>
                      <li>
                        <img src="./assets/img/delete-0.png" alt="Eliminar archivo" (click)="eliminarArchivo(12, 'filePersoneria')">
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
            <div class="terminos-condiciones-inline">
              <ul>
                <li>
                  <h3>Términos y condiciones.</h3>
                </li>
                <li>
                  <p>
                    <strong>PRIMERO:</strong> Al aceptar los presentes términos y condiciones, el cliente declara que la información proporcionada en la solicitud de
                    postergación de pago de deuda, es verdadera y fidedigna.
                  </p>
                </li>
                <li>
                  <p>
                    Asimismo, mediante este acto, el cliente autoriza que todas las obligaciones derivadas del servicio de gas se radiquen en el inmueble en conformidad
                    a la normativa vigente.
                  </p>
                </li>
                <li>
                  <p>
                    <strong>SEGUNDO:</strong> El cliente faculta incondicional e irrevocablemente a Metrogas S.A. para cobrar la deuda en hasta 48 cuotas mensuales
                    sin multas ni intereses.
                  </p>
                </li>
                <li>
                  <p>
                    Las deudas postergadas de acuerdo con la Ley N°21.240, serán cobradas a partir del mes de enero de 2022.
                  </p>
                </li>
              </ul>
            </div>
            <div class="terminos-condiciones">
              <ul>
                <li>
                  <div class="box-campo-form">
                    <label class="container-checkbox">
                      <input type="checkbox" formControlName="terminos" name="terminos" value="terminos" required>
                      <span class="checkmark"></span>
                    </label>
                    <p>
                      <!--<a class="terminos" (click)="mostrarTerminos($event)">Acepto términos y condiciones.</a>-->
                      Acepto términos y condiciones.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <label class="container-checkbox">
                      <input type="checkbox" formControlName="postergacion" name="postergacion" value="postergacion">
                      <span class="checkmark"></span>
                    </label>
                    <p>
                      Acepto incorporación de deuda previa de hasta 5 UF.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <label class="container-checkbox">
                      <input type="checkbox" formControlName="newsletters" name="newsletters" value="newsletters">
                      <span class="checkmark"></span>
                    </label>
                    <p>
                      Acepto expresamente que Metrogas S.A me envíe comunicaciones de productos y servicios.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <label class="container-checkbox">
                      <input type="checkbox" formControlName="boletaElectronica" name="boletaElectronica" value="boletaElectronica">
                      <span class="checkmark"></span>
                    </label>
                    <p>
                      Acepto suscribirme al envío de boleta electrónica.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <label class="container-checkbox">
                      <input type="checkbox" formControlName="privacidad" name="privacidad" value="privacidad">
                      <span class="checkmark"></span>
                    </label>
                    <p>
                      <a style="cursor: pointer;" (click)="mostrarPrivacidad($event)">Acepto la Política de Privacidad de Metrogas.</a>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div class="footer">
              <div class="callToAcction">
                <input type="button" value="VOLVER" class="btn btn-volver-p2" (click)="gotoPaso(2)">
                <input type="button" value="GUARDAR" class="btn btn-continuar" (click)="onSubmit()">
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="paso-4" *ngIf="pasos[0]['P4'].I">
      <div class="body">
        <app-suscripcion-beneficio-covid19-satisfactoria></app-suscripcion-beneficio-covid19-satisfactoria>
      </div>
    </div>
  </div>
</div>

<div class="modal-privacidad">
  <div class="punto-informacion">
    <ul>
      <li>
        <h3>Política de privacidad de datos.</h3>
      </li>
    </ul>
    <div class="contenido-terminos">
      <ul>
        <li>
          <p>
            Acepto la Política de Privacidad de Metrogas.
          </p>
        </li>
        <li>
          <p>
            Uso de Información de los Datos de los Clientes.
          </p>
        </li>
        <li>
          <p>
            De conformidad con la Ley N° 19.628 sobre Protección de la Vida Privada (“Ley”), los datos personales que los clientes o consumidores, en adelante los “Clientes”,
            suministren en el sitio web de Metrogas o a través de sus canales de contacto telefónico o por correo electrónico, pasarán a formar parte de una base de datos de
            Metrogas S.A. y serán destinados única y exclusivamente para ser utilizados en los fines comerciales y operativos que motivaron su entrega y especialmente para
            la comunicación en general entre la empresa y sus Clientes, validar datos y responder sus consultas. Los datos no serán comunicados a otras empresas sin la
            expresa autorización de su titular.
          </p>
        </li>
        <li>
          <p>
            Sin perjuicio de lo anterior, Metrogas S.A. garantiza a los Clientes el libre ejercicio de sus derechos de información, modificación, cancelación y bloqueo
            de sus datos personales establecidos en la Ley. Por consiguiente, todo correo electrónico enviado a nuestros Clientes, incluye la opción de cancelar
            la subscripción cuando lo desee.
          </p>
        </li>
        <li>
          <p>
            Sobre la Conservación de los Datos.
          </p>
        </li>
        <li>
          <p>
            Los datos personales entregados serán mantenidos mientras que el Cliente no solicite la supresión de los mismos y por tanto, serán conservados por Metrogas
            durante los plazos legales para el cumplimiento de obligaciones.
          </p>
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="modal-requerido">
  <div class="punto-informacion">
    <h3>Debes completar todos los datos solicitados para continuar</h3>
    <br>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
    <br>
  </div>
</div>

<div class="modal-error">
  <div class="punto-informacion">
    <h3>Ha ocurrido un error, vuelva a intentarlo más tarde</h3>
    <br>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
    <br>
  </div>
</div>

<div class="modal-numero-cliente">
  <div class="punto-informacion">
    <!--<img class='img-numero-cliente' src='./assets/img/numero_cliente.png'>-->
    <img class='img-numero-cliente' src='./assets/img/conoce-numero-cliente.jpg' alt="Conoce tu número de cliente">
    <br>
    <p class="texto-numero-cliente">
      Si no tienes tu número de cliente obtenlo ingresando tu dirección en metrogas.cl
      <!--El número de cliente aparece en la parte superior de su boleta de gas.-->
    </p>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
    <br>
  </div>
</div>

<div class="modal-declaracion-jurada">
  <embed class='zoom-pdf' src='./assets/docs/propuesta-declaracion-jurada-simple.pdf' type='application/pdf' />
</div>

<ngx-spinner></ngx-spinner>
